export default {
    getErrors: state => state.errors,
    getImageInfo: state => state.imageInfo,
    getImages: state => state.images,
    getProfilePictureChange: state => state.profileCardPictureChange
};